import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimWorkOrderChangeSeasonsGql } from '../bimWorkOrderChangeStructureQueries';

const getBimWorkOrderActiveSeasonRangeId = 'bimWorkOrderChangeSeasonsRange';

export const useBimWorkOrderChangeSeasonRange = ({
    workOrderChangeId,
    withEffect = true,
}: {
    workOrderChangeId: number | undefined;
    withEffect?: boolean;
}) => {
    const dispatch = useDispatch();

    const getSeasonRangeVariables = useMemo(() => ({ workOrderChangeId }), [workOrderChangeId]);

    const [bimWorkOrderSeasonRangeData, bimWorkOrderSeasonRangeStatus, , bimWorkOrderSeasonRangeMakeRequest] =
        useRequest({
            requestId: getBimWorkOrderActiveSeasonRangeId,
            query: bimWorkOrderChangeSeasonsGql,
            withEffect: withEffect && Boolean(workOrderChangeId),
            variables: getSeasonRangeVariables,
        });

    const [bimWorkOrderActiveSeasonRangeReset] = useResetStoreData({ requestId: getBimWorkOrderActiveSeasonRangeId });

    const updateSeasonRange = useCallback(() => {
        dispatch(bimWorkOrderSeasonRangeMakeRequest(getSeasonRangeVariables));
    }, [bimWorkOrderSeasonRangeMakeRequest, dispatch, getSeasonRangeVariables]);

    return {
        bimWorkOrderSeasonRangeData: bimWorkOrderSeasonRangeData?.bimWorkOrderChangeSeasons?.data,
        bimWorkOrderActiveSeasonRangeReset,
        bimWorkOrderSeasonRangeStatus,
        bimWorkOrderChangeSeasonRangeUpdate: updateSeasonRange,
    };
};
